import { Coffee } from "lucide-react";
import GlassCard from "./ui/GlassCard";
import StatPill from "./ui/StatPill";
import { useAuth } from "../context/authContext";
import { useState, useEffect } from "react";
import serverUrl from "../utils/utilsser";

const TAKE_BREAK_URL = (code) =>
  `${serverUrl}api/v1/users/takeBreakCount/${code}`;

function TakeBreakCount() {
  const { code } = useAuth();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        const res = await fetch(TAKE_BREAK_URL(code));
        const json = await res.json();
        if (!cancelled) setData(json?.data ?? null);
      } catch (err) {
        console.log(err);
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <GlassCard accent="purple" className="text-slate-900 dark:text-white">
      <StatPill
        icon={<Coffee size={20} />}
        value={loading ? "..." : (data?.totalCount ?? 0)}
        label={
          <span className="flex flex-col leading-tight">
            <span>Take a Break</span>
            {!loading && (data?.uniqueUsers ?? 0) > 0 && (
              <span className="mt-0.5 text-[11px] font-medium text-[#f6ad3c]">
                by {data.uniqueUsers}
                {data.totalUsers ? ` of ${data.totalUsers}` : ""}{" "}
                {(data.totalUsers ?? data.uniqueUsers === 1)
                  ? "unique user"
                  : "unique users"}
              </span>
            )}
          </span>
        }
        accent="#f6ad3c"
      />
    </GlassCard>
  );
}
var Take_Break = TakeBreakCount;
export { Take_Break as default };
